module.exports = __webpack_public_path__ + "static/media/ai-agents.372e0d84.png";